import { useQuery } from "@tanstack/react-query";
import { getBettingRules } from "@/api/bettingRules";
import { BettingRulesQueryKeys } from "./bettingRulesQueryKeys";

export const useBettingRules = (targetUsername?: string) => {
  return useQuery({
    queryKey: [BettingRulesQueryKeys.BettingRules, targetUsername],
    queryFn: ({ signal }) =>
      getBettingRules({ signal, params: { targetUsername } }),
  });
};
